import { api } from './api';

// The listing sources admin screen. Nothing here names a vendor: the source
// key comes from what the server has registered.
export const listingSourcesApi = {
    sources: () => api.get('/listing-sources').then((res) => res.data),
    saveSettings: (source, settings) =>
        api.post('/listing-sources/' + source + '/settings', settings).then((res) => res.data),
    // A dry run decides everything and writes nothing, so the mode is always
    // stated rather than defaulted at the call site.
    runNow: (source, mode) =>
        api.post('/listing-sources/' + source + '/runs', { mode: mode || 'write' }).then((res) => res.data),

    unmapped: (source) => api.get('/listing-sources/' + source + '/unmapped').then((res) => res.data),

    // One listing across recent runs, by its id in the source or by the
    // property it wrote. Both are numbers; the server refuses anything else.
    search: (source, q) => api.get('/listing-sources/' + source + '/search', { q }).then((res) => res.data),

    // The whole envelope for the paged lists: meta carries the page count, and
    // the screen needs it to know whether there is more to show.
    runs: (source, page) => api.get('/listing-sources/' + source + '/runs', { page }),
    runItems: (runId, outcome, page) => api.get('/process-runs/' + runId + '/items', { outcome, page }),
};
